import { render, staticRenderFns } from "./BroadcastsList.vue?vue&type=template&id=6c84ca1a&scoped=true"
import script from "./BroadcastsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BroadcastsList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BroadcastsList.vue?vue&type=style&index=0&id=6c84ca1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c84ca1a",
  null
  
)

export default component.exports